/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path utils
 * @description Notification about MyTasks
 */
const getFileApiURL = (filepath: string) => {
  if (filepath.includes("/api/files/?file="))
    return `${process.env.REACT_APP_SERVER_URL}/${filepath}`;
  return `${process.env.REACT_APP_SERVER_URL}/api/files/?file=${filepath}`;
};
const checkIfExternal = (link: string): boolean => {
  const host = window.location.hostname;
  const linkHost = (): string => {
    if (/^https?:\/\//.test(link)) {
      const parser = document.createElement("a");
      parser.href = link;
      return parser.hostname;
    }
    return window.location.hostname;
  };
  return host !== linkHost();
};
const isValidUrl = (string: string) => {
  try {
    // eslint-disable-next-line no-new
    new URL(string);
  } catch (_) {
    return false;
  }
  return true;
};
// url-reformer
// make sure that url path ends with a slash
const makeUrlPathEndingWithSlash = (aUrl: string): string | undefined => {
  let newUrl;
  // if have query part and path does not end to slash, make ? be /?
  if (aUrl.indexOf("?") !== -1) {
    if (aUrl.indexOf("/?") === -1) {
      newUrl = aUrl.replace("?", "/?");
    }
  }
  // no query part, then add slash if not ending with it already
  else if (!aUrl.endsWith("/")) {
    newUrl = `${aUrl}/`;
  }
  // undefined indicates no change is needed
  return newUrl;
};
function readCookieValue(name: string) {
  // from: https://stackoverflow.com/questions/5639346/what-is-the-shortest-function-for-reading-a-cookie-by-name-in-javascript
  return (document.cookie.match(`(^|;) *${name}=([^;]*)`) || "")[2];
}
const isValidId = (a: string): boolean => {
  return a.match(/^(PG|PO|SC)(\.\d+)+$/) !== null;
};
// check if element id is formed PG.1 or not
const isModelId = (a: string): boolean => {
  return a.match(/^(PG|PO|SC)\.\d+$/) !== null;
};
// check if element id is formed PG.1.2 or not
const isElementId = (a: string): boolean => {
  return a.match(/^(PG|PO|SC)\.\d+\.\d+$/) !== null;
};
// check if element id is formed PG.1.2.3 or not
const isInstanceId = (a: string): boolean => {
  return a.match(/^(PG|PO|SC)+\.\d+\.\d+\.\d+$/) !== null;
};
const isMongoId = (id: string): boolean => {
  return /^[a-f0-9]{24}$/i.test(id);
};
export {
  checkIfExternal,
  makeUrlPathEndingWithSlash,
  readCookieValue,
  isElementId,
  isInstanceId,
  isModelId,
  isValidId,
  isValidUrl,
  isMongoId,
  getFileApiURL,
};
